import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import { FormError } from '../../../FormError.jsx';
import ExampleCSVDownloadButton from '../ExampleCSVDownloadButton.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import FormStepsNav from './FormStepsNav.jsx';
import CurrentCSVDownloadButton from '../CurrentCSVDownloadButton.jsx';
import CustomRadio from '../../../CustomRadio.jsx';

export const groupsUploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  { label: 'Add new participant to an existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

function StepGroupParticipantsCsvForm({
  handleSubmit,
  formRef,
  submitError,
  submitFailed,
  submitting,
  onCancel,
  selectedCsvName,
  uploadMethod,
  setUploadMethod,
  replaceMethod,
  setReplaceMethod,
  onDownloadCsv,
  editing,
  stakeholderDraft,
  onBack,
  values,
  participantsEditAllowed,
}) {
  const [showFileField, setShowFileField] = useState(true);
  useEffect(() => {
    selectedCsvName && setShowFileField(false);
  }, [selectedCsvName]);

  return (
    <form ref={formRef}>
      <Row>
        <FormStepsNav activeIndex={2} onSubmit={handleSubmit} onBack={onBack} />
      </Row>

      {participantsEditAllowed ? (
        <React.Fragment>
          <Row>
            <Col xs={6}>
              <p className="text-muted m-b-32">
                If needed, select a organization-wide group(s) that forms part
                of this Stakeholder profile. For example: Human Resources.
              </p>
            </Col>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Add People</h3>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p className="text-muted m-b-24">
                Upload a CSV or add Group(s) manually.
              </p>
              <div className="m-b-18">
                <CustomRadio
                  name="uploadMethod"
                  checkedValue={uploadMethod}
                  options={groupsUploadMethodOptions}
                  action={setUploadMethod}
                />
              </div>
            </Col>
          </Row>

          {uploadMethod === 'csv' ? (
            <React.Fragment>
              {editing && stakeholderDraft?.groups_data ? (
                <Row className="m-b-48">
                  <Col xs={12}>
                    <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                      <h3>Existing Structure</h3>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className="m-b-18">
                      <CustomRadio
                        name="replaceMethod"
                        checkedValue={replaceMethod}
                        options={replaceOptions}
                        action={setReplaceMethod}
                      />
                    </div>
                  </Col>

                  <Col xs={12}>
                    <CurrentCSVDownloadButton onDownloadCsv={onDownloadCsv} />
                  </Col>
                </Row>
              ) : null}
              <Row className="m-b-24">
                <Col xs={12}>
                  <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                    <h3>Bulk CSV Upload</h3>
                  </div>
                </Col>

                {!selectedCsvName ? (
                  <Col xs={12}>
                    <div className="m-b-18">
                      <ExampleCSVDownloadButton />
                    </div>
                  </Col>
                ) : null}

                {showFileField ? (
                  <Col xs={12}>
                    <Field
                      id="groupsFormCsvFile"
                      name="stakeholder[csv_groups_file]"
                      type="file"
                      component={FieldGroup}
                      accept=".csv"
                    />
                  </Col>
                ) : null}
              </Row>
            </React.Fragment>
          ) : null}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Participants</h3>
          </div>
          <p className="text-muted m-b-48">
            It’s not allowed to change participants in outdated change impacts.
            If you want to proceed, please correct change impact dates first.
          </p>
        </React.Fragment>
      )}

      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={submitting}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepGroupParticipantsCsvForm;
